// extracted by mini-css-extract-plugin
export default {"wrapper":"RA1mN"};